<template>
  <div id="projects-tab">
    <k-panel :hasContentToggle="false">
      <template #body>
        <k-table class="projects-table"
          :headers="kableHeaders"
          :rows="kableRows"
          :hideable="false"
          :max="10"
          :panel="false"
          :loading="!projectsReady">
        </k-table>
     </template>
    </k-panel>
  </div>
</template>

<script>
import KPanel from '@base-components/k-panel.vue';
import KTable from '@base-components/tables/display/k-table.vue';

export default {
  components: {
    KTable,
    KPanel,
  },

  beforeMount() {
    this.getProjects();
  },

  watch: {
    programmeId() {
      this.getProjects();
    },
  },

  props: {
    userId: {
      type: Number,
      required: true,
    },
    programmeId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      projectsReady: false,
      projects: [],
    };
  },

  computed: {
    kableHeaders() {
      return {
        projectName: {
          name: 'Project Name',
          type: 'string',
          filterable: true,
          sortable: true,
        },
        projectDescription: {
          name: 'Description',
          type: 'string',
          filterable: true,
          sortable: true,
        },
        status: {
          name: 'Status',
          type: 'pill',
          hasDropdown: true,
          sortable: false,
          options: {
            type: status => ({
              'Scope Proposed': 'proposed',
              'In Progress': 'primary',
              Completed: 'success',
              Draft: 'neutral',
            }[status] || 'neutral'),
          },
        },
        scopingStatus: {
          name: 'Scoping',
          type: 'string',
          filterable: true,
          sortable: true,
        },
      };
    },

    kableRows() {
      return this.projects.map(project => ({
        projectName: project.name,
        projectDescription: project.description,
        status: this.getStatusDisplayName(project.status),
        scopingStatus: project.scoping_completed ? 'Completed' : 'Pending',
      }));
    },
  },

  methods: {
    getProjects() {
      this.projectsReady = false;
      this.$logger.info('Fetching learner projects');
      this.$http.get(`/api/curriculum/admin/programmes/${this.programmeId}/projects/learner/${this.userId}`)
        .then(response => {
          this.$logger.info('Successfully fetched learner projects');
          this.projects = response.data;
        })
        .catch(error => {
          this.$logger.error('Error fetching learner projects', undefined, error);
          this.$ktoast.showError(error, true);
        }).then(() => {
          this.projectsReady = true;
        });
    },

    getStatusDisplayName(status) {
      const displayMap = {
        scoping_proposed: 'Scope Proposed',
        in_progress: 'In Progress',
        completed: 'Completed',
        draft: 'Draft',
      };
      return displayMap[status] || status;
    },
  },
};
</script>
